// extracted by mini-css-extract-plugin
module.exports = {"QrReader":"QrReader_QrReader__Bqxpx","QrReaderModule":"QrReader_QrReaderModule__CUa00"};